import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import Controls from "../components/controls/Controls";
import { useFormik } from "formik";
import * as yup from "yup";
import { useForm, Form } from "../components/useForm";
import * as employeeService from "../services/employeeService";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

const validationSchema = yup.object({
  firstName: yup
    .string("Enter your first name")
    .required("First name is required"),
  lastName: yup
    .string("Enter your first name")
    .required("First name is required"),
  phone: yup
    .string("Enter your phone number")
    .required("Phone number is required"),
  email: yup.string("Enter email").required("Email is required"),
  password: yup
    .string("Enter password")
    .min(4)
    .required("Password is required"),
  NIC: yup
    .string("Enter your id card number")
    .required("Id card number is required"),
  address: yup.string("Enter your address"),
  joinDate: yup.date(),
  // .min(new Date("2010-10-01"), "date min")
  // .required("Join Date is required"),
  role: yup
    .mixed("Select role")
    .oneOf(["admin", "moderator"])
    .required("Role is required"),
});

export default function EmployeeForm(props) {
  const { addOrEdit, recordForEdit } = props;

  const formik = useFormik({
    initialValues: {
      // id: 0,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      NIC: "",
      address: "",
      role: "",
      joinDate: new Date(),
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const updateData = {
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        NIC: values.NIC,
        address: values.address,
        email: values.email,
        password: values.password,
        role: values.role,
        joinDate: values.joinDate,
      };

      let id;
      // alert(JSON.stringify(values, null, 2));
      if (values.id) addOrEdit(updateData, (id = values.id), formik.resetForm);
      if (!values.id) addOrEdit(values, (id = null), formik.resetForm);
    },
  });

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (recordForEdit != null) {
      formik.setValues({
        ...recordForEdit,
      });
    }
  }, []);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="firstName"
            label="First Name"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
          />
          <Controls.Input
            name="lastName"
            label="Last Name"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
          />
          <Controls.Select
            name="role"
            label="Role"
            value={formik.values.role}
            onChange={formik.handleChange}
            options={employeeService.getRolesCollection()}
            error={formik.touched.role && Boolean(formik.errors.role)}
            helperText={formik.touched.role && formik.errors.role}
          />
          <Controls.Input
            label="NIC No"
            name="NIC"
            value={formik.values.NIC}
            onChange={formik.handleChange}
            error={formik.touched.NIC && Boolean(formik.errors.NIC)}
            helperText={formik.touched.NIC && formik.errors.NIC}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            label="Phone"
            name="phone"
            value={formik.values.phone}
            onChange={formik.handleChange}
            error={formik.touched.phone && Boolean(formik.errors.phone)}
            helperText={formik.touched.phone && formik.errors.phone}
          />

          <Controls.Input
            label="Email"
            name="email"
            autoComplete="off"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <FormControl variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helpertext={formik.touched.password && formik.errors.password}
              size="small"
              label="Password"
              name="password"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <Controls.Input
            label="Address"
            name="address"
            value={formik.values.address}
            onChange={formik.handleChange}
            error={formik.touched.address && Boolean(formik.errors.address)}
            helperText={formik.touched.address && formik.errors.address}
          />
          <Controls.DatePicker
            name="joinDate"
            label="Join Date"
            value={formik.values.joinDate}
            onChange={formik.handleChange}
            error={formik.touched.joinDate && Boolean(formik.errors.joinDate)}
            helperText={formik.touched.joinDate && formik.errors.joinDate}
          />
          {/* <Controls.UploadButton /> */}
          {/* <Controls.Input
            label="Salary Per Day"
            name="salaryPerDay"
            type="number"
            InputProps={{ inputProps: { min: 1, step: 0.01 } }}
            value={values.salaryPerDay}
            onChange={handleInputChange}
            error={errors.salaryPerDay}
          />
          <Controls.Input
            label="Allowance"
            name="allowance"
            type="number"
            InputProps={{ inputProps: { min: 1, step: 0.01 } }}
            value={values.allowance}
            onChange={handleInputChange}
            error={errors.allowance}
          />
          <Controls.Input
            label="Bank"
            name="bank"
            value={values.bank}
            onChange={handleInputChange}
          />
          <Controls.Input
            label="Branch"
            name="branch"
            value={values.branch}
            onChange={handleInputChange}
          />
          <Controls.Input
            label="Bank Acc No"
            name="bankAccNo"
            value={values.bankAccNo}
            onChange={handleInputChange}
          /> */}

          {/* <Controls.RadioGroup
            name="gender"
            label="Gender"
            value={values.gender}
            onChange={handleInputChange}
            items={genderItems}
          />
          <Controls.Checkbox
            name="isPermanent"
            label="Permanent Employee"
            value={values.isPermanent}
            onChange={handleInputChange}
          /> */}
          <div>
            <Controls.Button type="submit" text="Submit" />
            <Controls.Button
              text="Reset"
              color="default"
              onClick={() => {
                formik.resetForm();
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
